
// Common timezones for US and Canada
export const timezones = [
  { value: 'America/New_York', label: 'Eastern Time (ET)' },
  { value: 'America/Chicago', label: 'Central Time (CT)' },
  { value: 'America/Denver', label: 'Mountain Time (MT)' },
  { value: 'America/Los_Angeles', label: 'Pacific Time (PT)' },
  { value: 'America/Anchorage', label: 'Alaska Time (AKT)' },
  { value: 'Pacific/Honolulu', label: 'Hawaii Time (HT)' },
  { value: 'America/Phoenix', label: 'Arizona Time (AZ)' },
  { value: 'America/Vancouver', label: 'Vancouver (PT)' },
  { value: 'America/Edmonton', label: 'Edmonton (MT)' },
  { value: 'America/Winnipeg', label: 'Winnipeg (CT)' },
  { value: 'America/Toronto', label: 'Toronto (ET)' },
  { value: 'America/Halifax', label: 'Halifax (AT)' },
  { value: 'America/St_Johns', label: 'Newfoundland (NT)' }
];
